import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const receiptsAccessControl: DomainAccessControlConfig = {
  featureToggles: FeatureToggle.receipts,
}
